import { useDispatch, useSelector } from "react-redux";
import { userRoles } from "../../../utils/constant";
import { useEffect, useState } from "react";
import { getFromLocalStorage } from "../../../utils/webStorage";
import FeedPostCard from "./FeedPostCard";
import {
  handleAthleteSelection,
  handleCoachSelection,
  setAllFeedPostList,
  shareVideo,
  toggleCoachesAthletesListPopup,
  toggleShareVideoPopup,
} from "../../../Redux/Actions/FeedPageActions";
import DialogBox from "../Popups/ReusablePopup/DialogBox";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import { Form, Formik } from "formik";
import ActiveAthleteCoachesListPopup from "../Popups/ActiveAthleteCoachesListPopup";
import { CircularProgress } from "@material-ui/core";
const FeedContainer = () => {
  const userId = getFromLocalStorage("currentUserId");
  const schoolId = getFromLocalStorage("schoolId");
  const loginUserProfile = getFromLocalStorage("loginUserProfile");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const userRole = useSelector((state) => state.loggedInUser.roles[0].role);
  const posts = useSelector((state) => state?.FeedPageData?.posts);
  const endTotalPost = useSelector(
    (state) => state?.FeedPageData?.endTotalPost
  );
  const {
    isOpen,
    isCoachAthleteListPopupOpen,
    coaches,
    athletes,
    selectedVideo,
  } = useSelector((state) => state?.FeedPageData?.videoSharing);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userRole == userRoles.ROLE_COACH ||
      userRole == userRoles.ROLE_ATHLETE ||
      userRole == userRoles.ROLE_TEAM_ADMIN
    ) {
      loadMore(page);
    }
  }, [page]);

  const isChecked = (columnId, id) => {
    if (columnId === "1") {
      return coaches.includes(id);
    }
    return athletes.includes(id);
  };

  const loadMore = async (page) => {
    setAllFeedPostList(dispatch, { schoolId, page, existingPosts: posts });
  };

  const toggleListPopUP = (status) => {
    toggleCoachesAthletesListPopup(dispatch, status);
  };

  const handleSelection = (id, role) => {
    if (role === "Coach") {
      const coachesIds = coaches?.includes(id)
        ? coaches?.filter((coachId) => coachId != id)
        : [...coaches, id];
      handleCoachSelection(dispatch, coachesIds);
    } else {
      const athletesIds = athletes?.includes(id)
        ? athletes?.filter((athleteId) => athleteId != id)
        : [...athletes, id];
      handleAthleteSelection(dispatch, athletesIds);
    }
  };

  const handleSubmit = (values) => {
    setLoading(true);
    shareVideo(dispatch, {
      ...values,
      ...selectedVideo,
      coaches,
      athletes,
      teamAdmins: [],
      schoolId,
      userId,
      loginUserProfile,
      shareOnId: 3,
    }).finally(() => {
      handleCoachSelection(dispatch, []);
      handleAthleteSelection(dispatch, []);
      setLoading(false);
    });
  };

  const isArrayEmpty = coaches.length > 0 || athletes.length > 0;
  return (
    <>
      {posts?.map((post, index) => (
        <FeedPostCard post={post} key={index} />
      ))}
      {posts.length != 0 && !endTotalPost && (
        <div className="d-flex justify-content-center">
          <button
            className="saveBtn1 mr-3"
            disabled={endTotalPost}
            onClick={() => setPage(page + 1)}
          >
            Load More
          </button>
        </div>
      )}
      {endTotalPost && (
        <div className="d-flex justify-content-center">
          <p className="nodatabox">
            You have reached the maximum number of posts.
          </p>
        </div>
      )}
      {isCoachAthleteListPopupOpen && (
        <ActiveAthleteCoachesListPopup
          open={isCoachAthleteListPopupOpen}
          togglePopup={toggleListPopUP}
          isArrayEmpty={isArrayEmpty}
          coachesForFeed={(id) => handleSelection(id, "Coach")}
          athleteForFeed={(id) => handleSelection(id, "Athlete")}
          isChecked={isChecked}
          handleListSubmit={() => toggleShareVideoPopup(dispatch, true)}
        />
      )}
      <DialogBox
        open={isOpen}
        onClose={() => toggleShareVideoPopup(dispatch, false)}
        variant="md"
        title={
          <div className="d-flex-space-between">
            <p className="bold">Share Video</p>
            <button
              className="breakdownTableCloseIcon"
              onClick={() => toggleShareVideoPopup(dispatch, false)}
            >
              <span>&times;</span>
            </button>
          </div>
        }
      >
        <Formik
          initialValues={{
            shareOption: "Share To Coaches / Athletes",
            videoTitle: "",
            videoDescription: "",
          }}
          validationSchema={validationSchema.shareVideoSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form>
              <FormikTextField
                label="Share"
                formik={formik}
                fieldName="shareOption"
                placeholder="Select Share"
                labelFontSize="fs-18"
                isDisabled={true}
              />
              <FormikTextField
                label="Video Title"
                formik={formik}
                fieldName="videoTitle"
                placeholder="Enter Video Title"
                labelFontSize="fs-18"
              />
              <FormikTextField
                label="Video Description"
                formik={formik}
                fieldName="videoDescription"
                placeholder="Enter Video Description"
                labelFontSize="fs-18"
              />
              <div className="d-flex-align-right">
                <button
                  className={formik.isValid ? "saveBtn1" : "saveBtn1 activv"}
                  type="submit"
                  disabled={!formik.isValid}
                >
                  {loading ? (
                    <CircularProgress size="1.5rem" className="white" />
                  ) : (
                    "Post"
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </DialogBox>
      {posts?.length == 0 && (
        <div className="row">
          <div className="col-lg-12">
            <p className="nodatabox">
              No feed available currently. Once you or your Coaches, Athletes
              share the content, it will become available here.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedContainer;
